(() => {
  const escapeHTML = (value = '') => {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  };

  const formatMoney = (cents, currency = 'USD') => {
    if (
      window.Shopify &&
      typeof Shopify.formatMoney === 'function' &&
      window.theme &&
      theme.moneyFormat
    ) {
      return Shopify.formatMoney(cents, theme.moneyFormat);
    }

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency
    }).format(Number(cents || 0) / 100);
  };

  const getCartChangeURL = () => {
    if (window.routes && routes.cart_change_url) {
      return routes.cart_change_url;
    }

    return '/cart/change.js';
  };

  const getRequestConfig = () => {
    const config =
      typeof window.fetchConfig === 'function'
        ? fetchConfig('javascript')
        : {};

    return {
      ...config,
      method: config.method || 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...(config.headers || {})
      }
    };
  };

  /*class MiniCartRemoveButton extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.handleClick = this.handleClick.bind(this);
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    async handleClick(event) {
      event.preventDefault();

      const item = this.closest('.minicart-item');
      const line = Number(item?.dataset.line);
      const miniCart = document.querySelector('mini-cart');

      if (!line || !miniCart) return;

      await miniCart.changeLine(line, 0);
    }
  }*/
 class MiniCartRemoveButton extends HTMLElement {}

if (!customElements.get('mini-cart-remove-button')) {
  customElements.define(
    'mini-cart-remove-button',
    MiniCartRemoveButton
  );
}

  if (!customElements.get('mini-cart-remove-button')) {
    customElements.define(
      'mini-cart-remove-button',
      MiniCartRemoveButton
    );
  }

  class MiniCart extends HTMLElement {
    connectedCallback() {
  /*
   * El minicart se carga originalmente dentro del header.
   * Lo movemos directamente al body para evitar que el encabezado
   * recorte o esconda el fondo oscuro.
   */
  if (this.parentElement !== document.body) {
    document.body.appendChild(this);
    return;
  }

  if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';

      this.drawer = this.querySelector('#minicart');
      this.overlay = this.querySelector('.minicart-overlay');
      this.cartIcon = document.querySelector('#cart-icon-bubble');
      this.closeButton = this.querySelector('.minicart-drawer__close');

      this.quantityTimeout = null;
      this.lastFocusedElement = null;

      this.handleCartIconClick =
        this.handleCartIconClick.bind(this);

      this.handleDrawerClick =
        this.handleDrawerClick.bind(this);

      this.handleQuantityChange =
        this.handleQuantityChange.bind(this);

      this.handleKeyDown =
        this.handleKeyDown.bind(this);

      this.cartIcon?.addEventListener(
        'click',
        this.handleCartIconClick
      );

      this.addEventListener(
        'click',
        this.handleDrawerClick
      );

      this.addEventListener(
        'change',
        this.handleQuantityChange
      );

      document.addEventListener(
        'keydown',
        this.handleKeyDown
      );
    }

    disconnectedCallback() {
      if (this.dataset.initialized !== 'true') return;
      
      this.cartIcon?.removeEventListener(
        'click',
        this.handleCartIconClick
      );

      this.removeEventListener(
        'click',
        this.handleDrawerClick
      );

      this.removeEventListener(
        'change',
        this.handleQuantityChange
      );

      document.removeEventListener(
        'keydown',
        this.handleKeyDown
      );
    }

    handleCartIconClick(event) {
      event.preventDefault();

      if (this.classList.contains('is-open')) {
        this.close();
      } else {
        this.open();
      }
    }

    /*handleDrawerClick(event) {
      const closeTrigger = event.target.closest(
        '[data-minicart-close]'
      );

      if (closeTrigger) {
        event.preventDefault();
        this.close();
      }
    }*/
  async handleDrawerClick(event) {
  const removeTrigger = event.target.closest(
    '.mimicart-item__remove'
  );

  if (removeTrigger) {
    event.preventDefault();
    event.stopPropagation();

    const item = removeTrigger.closest(
      '.minicart-item'
    );

    const line = Number(item?.dataset.line);

    if (line) {
      await this.changeLine(line, 0);
    }

    return;
  }

  const closeTrigger = event.target.closest(
    '[data-minicart-close]'
  );

  if (closeTrigger) {
    event.preventDefault();
    this.close();
  }
}

    handleKeyDown(event) {
      if (
        event.key === 'Escape' &&
        this.classList.contains('is-open')
      ) {
        this.close();
      }
    }

    handleQuantityChange(event) {
      const input = event.target.closest(
        '.quantity__input'
      );

      if (!input) return;

      clearTimeout(this.quantityTimeout);

      const quantity = Math.max(
        0,
        Number.parseInt(input.value, 10) || 0
      );

      const item = input.closest('.minicart-item');
      const line = Number(item?.dataset.line);

      if (!line) return;

      this.quantityTimeout = setTimeout(() => {
        this.changeLine(line, quantity);
      }, 300);
    }

    open() {
      if (!this.drawer) return;

      this.lastFocusedElement =
        document.activeElement;

      this.classList.add('is-open');
      this.drawer.classList.add('active');
      this.drawer.setAttribute('aria-hidden', 'false');

      document.body.classList.add('minicart-open');

      window.setTimeout(() => {
        this.closeButton?.focus();
      }, 250);
    }

    close() {
      if (!this.drawer) return;

      this.classList.remove('is-open');
      this.drawer.classList.remove('active');
      this.drawer.setAttribute('aria-hidden', 'true');

      document.body.classList.remove('minicart-open');

      if (
        this.lastFocusedElement &&
        typeof this.lastFocusedElement.focus === 'function'
      ) {
        this.lastFocusedElement.focus();
      }
    }

    toggle() {
      if (this.classList.contains('is-open')) {
        this.close();
      } else {
        this.open();
      }
    }

    setLoading(status) {
      this.drawer?.classList.toggle(
        'is-loading',
        Boolean(status)
      );
    }

    async changeLine(line, quantity) {
      this.setLoading(true);

      try {
        const response = await fetch(
          getCartChangeURL(),
          {
            ...getRequestConfig(),
            body: JSON.stringify({
              line,
              quantity
            })
          }
        );

        if (!response.ok) {
          throw new Error(
            `Cart update failed: ${response.status}`
          );
        }

        const cart = await response.json();

        this.render(cart);
        this.open();
      } catch (error) {
        console.error('Mini cart error:', error);
      } finally {
        this.setLoading(false);
      }
    }

    async update() {
      this.setLoading(true);

      try {
        const response = await fetch('/cart.js', {
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(
            `Cart request failed: ${response.status}`
          );
        }

        const cart = await response.json();

        this.render(cart);

        /*
         * El tema normalmente llama update() después de agregar
         * un producto. Por eso abrimos automáticamente el drawer.
         */
        this.open();
      } catch (error) {
        console.error('Mini cart error:', error);
      } finally {
        this.setLoading(false);
      }
    }

    render(cart) {
      const list = this.querySelector(
        '.list-mimicart'
      );

      const emptyState = this.querySelector(
        '.minicart-empty'
      );

      const footer = this.querySelector(
        '.minicart-drawer__footer'
      );

      const freeShipping = this.querySelector(
        '.minicart-free-shipping'
      );

      const checkoutButton = this.querySelector(
        '.cart__checkout-button'
      );

      const totalPrice = this.querySelector(
        '.minicart-total-price'
      );

      const originalTotalPrice = this.querySelector(
        '.minicart-original-total'
      );

      const checkoutTotal = this.querySelector(
        '.minicart-checkout-total'
      );

      const subtotalLabel = this.querySelector(
        '.minicart-subtotal-label'
      );

      const drawerCount = this.querySelector(
        '.minicart-drawer__count'
      );

      const isEmpty = cart.item_count === 0;

      if (list) {
        list.innerHTML = cart.items
          .map((item, index) =>
            this.renderItem(item, index + 1, cart.currency)
          )
          .join('');

        list.classList.toggle('hidden', isEmpty);
      }

      emptyState?.classList.toggle(
        'hidden',
        !isEmpty
      );

      footer?.classList.toggle(
        'hidden',
        isEmpty
      );

      freeShipping?.classList.toggle(
        'hidden',
        isEmpty
      );

      if (checkoutButton) {
        checkoutButton.disabled = isEmpty;
      }

      const currentTotal = Number(cart.total_price || 0);

const calculatedOriginalTotal = (cart.items || []).reduce(
  (total, item) => {
    const originalLinePrice =
      item.original_line_price ??
      ((item.original_price ?? item.price ?? 0) *
        (item.quantity || 0));

    return total + Number(originalLinePrice || 0);
  },
  0
);

const originalTotal =
  Number(cart.original_total_price) > 0
    ? Number(cart.original_total_price)
    : calculatedOriginalTotal;

const formattedCurrentTotal = formatMoney(
  currentTotal,
  cart.currency
);

const formattedOriginalTotal = formatMoney(
  originalTotal,
  cart.currency
);

/* Precio actual del subtotal */

if (totalPrice) {
  totalPrice.innerHTML = formattedCurrentTotal;
}

/* Precio dentro del botón Checkout */

if (checkoutTotal) {
  checkoutTotal.innerHTML = formattedCurrentTotal;
}

/* Cantidad de artículos */

if (subtotalLabel) {
  const itemCount = Number(cart.item_count || 0);
  const itemText = itemCount === 1 ? 'item' : 'items';

  subtotalLabel.textContent =
    `Subtotal (${itemCount} ${itemText})`;
}

/* Precio original tachado */

if (originalTotalPrice) {
  const hasDiscount = originalTotal > currentTotal;

  originalTotalPrice.innerHTML =
    formattedOriginalTotal;

  originalTotalPrice.classList.toggle(
    'hidden',
    !hasDiscount
  );
}

      if (drawerCount) {
        drawerCount.textContent =
          cart.item_count;
      }

      this.updateHeaderCount(
        cart.item_count
      );

      const freeShippingElement =
        this.querySelector('cart-freeshipping') ||
        document.querySelector('cart-freeshipping');

      if (
        freeShippingElement &&
        typeof freeShippingElement.update === 'function'
      ) {
        freeShippingElement.update(
          cart.total_price
        );
      }

      /*if (
        typeof window.updateCurrencies === 'function'
      ) {
        updateCurrencies();
      }*/

      if (
        typeof window.displayCrossSell === 'function'
      ) {
        displayCrossSell();
      }

      document
        .querySelector('#jsUpsell')
        ?.remove();

      document.dispatchEvent(
        new CustomEvent('minicart:updated', {
          detail: { cart }
        })
      );
      
    }

renderItem(item, line, currency) {
  const title = escapeHTML(
    item.product_title || item.title || ''
  );

  const url = escapeHTML(
    item.url || '#'
  );

  const quantity = Number(item.quantity || 0);

  const currentPrice = Number(
    item.final_price ?? item.price ?? 0
  );

  const originalPrice = Number(
    item.original_price ?? item.price ?? currentPrice
  );

  const savings = Math.max(
    0,
    originalPrice - currentPrice
  );

  const image = item.image
    ? `
      <a
        class="image-product"
        href="${url}"
        aria-label="${title}"
      >
        <img
          class="mimicart-item__image"
          src="${escapeHTML(item.image)}"
          alt="${title}"
          width="90"
          height="100"
          loading="lazy"
        >
      </a>
    `
    : `
      <div
        class="image-product image-product--empty"
        aria-hidden="true"
      ></div>
    `;

  const variant =
    item.variant_title &&
    item.variant_title !== 'Default Title'
      ? `
        <div class="mimicart-item__variant">
          ${escapeHTML(item.variant_title)}
        </div>
      `
      : '';

  const oldPrice =
    originalPrice > currentPrice
      ? `
        <span class="mimicart-item__old-price">
          ${formatMoney(originalPrice, currency)}
        </span>
      `
      : '';

  const savingText =
    savings > 0
      ? `
        <span class="mimicart-item__saving">
          Save ${formatMoney(savings, currency)}
        </span>
      `
      : '';

  return `
    <div
      class="minicart-item"
      data-line="${line}"
    >
      ${image}

      <div class="minicart-price">
        <a
          href="${url}"
          class="mimicart-item__name"
        >
          ${title}
        </a>

        ${variant}

        <div class="mimicart-item__prices">
          ${oldPrice}

          <span class="price price--end">
            ${formatMoney(currentPrice, currency)}
          </span>
        </div>

        ${savingText}

        <quantity-input class="quantity">
          <button
            class="quantity__button no-js-hidden"
            name="minus"
            type="button"
            aria-label="Decrease quantity"
          >
            <svg
              aria-hidden="true"
              focusable="false"
              viewBox="0 0 10 2"
              class="icon icon-minus"
            >
              <path
                d="M1 1h8"
                stroke="currentColor"
                stroke-width="1.2"
              ></path>
            </svg>
          </button>

          <input
            class="quantity__input"
            type="number"
            name="updates[]"
            value="${quantity}"
            min="0"
            id="MiniCart-Quantity-${line}"
            data-index="${line}"
            aria-label="Quantity for ${title}"
          >

          <button
            class="quantity__button no-js-hidden"
            name="plus"
            type="button"
            aria-label="Increase quantity"
          >
            <svg
              aria-hidden="true"
              focusable="false"
              viewBox="0 0 10 10"
              class="icon icon-plus"
            >
              <path
                d="M5 1v8M1 5h8"
                stroke="currentColor"
                stroke-width="1.2"
              ></path>
            </svg>
          </button>
        </quantity-input>
      </div>

      <mini-cart-remove-button>
        <button
          type="button"
          class="mimicart-item__remove"
          aria-label="Remove ${title}"
        >
          Remove
        </button>
      </mini-cart-remove-button>
    </div>
  `;
}

    updateHeaderCount(count) {
      const icon = document.querySelector(
        '#cart-icon-bubble'
      );

      if (!icon) return;

      const emptyCount = icon.querySelector(
        '.cart-count-cart-empty'
      );

      let bubble = icon.querySelector(
        '.cart-count-bubble'
      );

      if (count > 0) {
        if (emptyCount) {
          emptyCount.style.display = 'none';
        }

        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = `
            <span aria-hidden="true">${count}</span>
            <span class="visually-hidden">
              ${count} items
            </span>
          `;

          icon.appendChild(bubble);
        } else {
          const visibleCount =
            bubble.querySelector(
              'span:first-child'
            );

          const hiddenCount =
            bubble.querySelector(
              '.visually-hidden'
            );

          if (visibleCount) {
            visibleCount.textContent = count;
          }

          if (hiddenCount) {
            hiddenCount.textContent =
              `${count} items`;
          }
        }
      } else {
        bubble?.remove();

        if (emptyCount) {
          emptyCount.textContent = '0';
          emptyCount.style.display = '';
        }
      }
    }

    /*
     * Se mantienen para compatibilidad con otros archivos del tema
     * que pudieran llamar estas funciones.
     */
    updateRow() {}

    display() {}
  }

  if (!customElements.get('mini-cart')) {
    customElements.define(
      'mini-cart',
      MiniCart
    );
  }
})();